import React from "react"
import Radio from "../../../../shared/components/fields/radio"
import classNames from "classnames"
import { FieldErrors, UseFormRegisterReturn } from "react-hook-form"

interface RadioBoxProps {
    icon?: string
    headline?: string
    label: string
    options: string[]
    errors?: FieldErrors
    register: UseFormRegisterReturn
}

const RadioBox = ({ icon, headline, label, options, errors, register }: RadioBoxProps) => {
    return (
        <div
            className={classNames(
                "rounded-base border border-border-tide p-7 sm:rounded-lg sm:p-10",
                icon || headline ? "mt-3.5 pt-0 sm:mt-4 sm:pt-0" : "pt-7 sm:pt-10"
            )}
        >
            {icon && headline && (
                <div className="-mt-3.5 mb-5 flex w-fit gap-2 bg-white px-2 sm:-mt-4.5">
                    <i className="lavita-icon text-2xl leading-none text-orange sm:text-3xl">{icon}</i>
                    <h3 className="place-content-center font-gibson text-base sm:text-lg">{headline}</h3>
                </div>
            )}
            <div className="[&_legend]:mb-7 [&_legend]:text-base [&_legend]:font-semibold sm:[&_legend]:text-md lg:[&_legend]:text-lg">
                <Radio
                    register={register}
                    error={errors}
                    label={label}
                    options={options.map(option => ({
                        label: option,
                        value: option,
                    }))}
                />
            </div>
        </div>
    )
}

export default RadioBox
